module.exports = __webpack_public_path__ + "static/media/christmas.27bb8fbc.svg";